/*
 * bv-summary-skeleton.js
 *
 * The PDP rating summary (`<div data-bv-show="rating_summary">` inside
 * `.bv-summary`) is empty until Bazaarvoice's `bv.js` fetches review data and
 * injects the stars widget — so the rating used to pop in abruptly. The snippet
 * renders a shimmering star skeleton (`.bv-summary-skeleton`) inside a
 * `.bv-summary-block` wrapper; this script hides it by adding `.is-bv-loaded`
 * to the wrapper as soon as BV injects content into the container.
 *
 * A MutationObserver covers the async fill; a timeout covers products with NO
 * reviews (BV never fills the container, so the skeleton must not shimmer
 * forever). The init guard keeps duplicate script tags from re-binding.
 */
(function () {
  if (window.__bvSummarySkeletonInit) return;
  window.__bvSummarySkeletonInit = true;

  var TIMEOUT_MS = 8000;

  function bindBlock(block) {
    if (block.dataset.bvSkeletonBound) return;
    block.dataset.bvSkeletonBound = '1';

    var box = block.querySelector('[data-bv-show]');
    if (!box) {
      block.classList.add('is-bv-loaded');
      return;
    }

    var observer = null;
    var timer = null;
    var FADE_MS = 350;
    var done = function () {
      block.classList.add('is-bv-loaded');
      // Drive the cross-fade inline (inline opacity wins the cascade cleanly),
      // then guarantee the skeleton is fully removed once the fade finishes —
      // so it can never linger on top of the real rating even if the CSS
      // opacity transition is skipped for any reason.
      var skeleton = block.querySelector('.bv-summary-skeleton');
      if (skeleton) {
        skeleton.style.opacity = '0';
        setTimeout(function () {
          skeleton.style.display = 'none';
        }, FADE_MS + 50);
      }
      if (observer) observer.disconnect();
      if (timer) clearTimeout(timer);
    };

    // Already filled (e.g. bfcache restore or fast BV load before bind ran).
    if (box.childElementCount > 0) {
      done();
      return;
    }

    observer = new MutationObserver(function () {
      if (box.childElementCount > 0) done();
    });
    observer.observe(box, { childList: true });

    // No-reviews fallback: stop the shimmer even if BV never fills the container.
    timer = setTimeout(done, TIMEOUT_MS);
  }

  function init() {
    var blocks = document.querySelectorAll('.bv-summary-block');
    for (var i = 0; i < blocks.length; i++) bindBlock(blocks[i]);
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
  window.addEventListener('load', init);
})();
